import { z } from '../utils/zod-extend'

export const stringArrayParamSchema = z.union([
  z.string().array(),
  z.string(),
]).transform((v) => {
  if (Array.isArray(v)) {
    return v
  } else {
    return [v]
  }
})
